const buildFilters = (filter) => {
  const newFilter = Object.fromEntries(Object.entries(filter).filter(([, val]) => val.length > 0));
  return newFilter;
};

export default buildFilters;
